import { useMemo, useState } from "react";
import GoogleMap from "google-maps-react-markers";
import moment from 'moment/moment';
import env from "../../env/src_config";
import { displayDate } from "../../izUtils";

// Marker component for location points
const LocationMarker = ({ time }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'relative',
      }}
    >
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: "#3b82f6",
          border: "2px solid white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
          transform: "translate(-50%, -50%)",
          cursor: "pointer",
        }}
      />
      {isHovered && time && (
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '8px',
            padding: '8px 12px',
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            color: '#fff',
            borderRadius: '4px',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            zIndex: 1000,
            pointerEvents: 'none',
          }}
        >
          {time}
        </div>
      )}
    </div>
  );
};

export default function TimelineMapTracker({ locations = [] }) {
  const normalized = useMemo(() => {
    return (locations || [])
      .filter((p) => p && typeof p.lat === "number" && typeof p.lon === "number")
      .map((p) => {
        let formattedTime = "";
        if (p.timestamp) {
          formattedTime = displayDate(moment.utc(p.timestamp).local().toDate(), 'datetime');
        }

        return {
          lat: Number(p.lat),
          lon: Number(p.lon),
          time: formattedTime,
        };
      });
  }, [locations]);

  return (
    <div className="w-100 h-100">
      <div style={{ height: "600px", width: "100%" }}>
        <GoogleMap
          apiKey={env.google_maps_api_key}
          defaultCenter={{ lat: 46.1203255, lng: 14.8156076 }}
          defaultZoom={9}
          mapMinHeight="600px"
        >
          {normalized.map((point, i) => (
            <LocationMarker
              key={i}
              lat={point.lat}
              lng={point.lon}
              time={point.time}
            />
          ))}
        </GoogleMap>
      </div>
    </div>
  );
}
